import { PaymentMethods } from '@bpm-web-app/components';

export default function AccountPayment({ title }: { title: string }) {
    return (
        <PaymentMethods platform="create" title={title} />
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'Account Payment'
        }
    };
}
